


export const layouts = {
'base': () => import('/opt/build/repo/src/layouts/base.vue'),
'callbacklayout': () => import('/opt/build/repo/src/layouts/callbacklayout.vue'),
'empty': () => import('/opt/build/repo/src/layouts/empty.vue'),
'fullscreen': () => import('/opt/build/repo/src/layouts/fullscreen.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      component: layouts[route.meta?.layout || 'base'],
      children: [ {...route, path: ''} ],
    }
  })
}
